import { Component, DestroyRef, inject, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  CUSTOM_CODE_DIALOG_CONFIG,
  CustomCodeDialogData,
  CustomCodeDialogResult,
  SmartCartFormCustomCodeDialogComponent,
} from './custom-code-dialog.component';
import { CustomCodeVariableDoc } from './custom-code.model';

@Component({
  selector: 'smart-cart-form-custom-code',
  templateUrl: './custom-code.component.html',
  styleUrls: ['./custom-code.component.scss'],
  standalone: false,
})
export class SmartCartFormCustomCodeComponent {
  @Input({ required: true }) enabledControl!: FormControl<boolean>;
  @Input({ required: true }) codeControl!: FormControl<string>;
  @Input() defaultCode = '';
  @Input() variables: CustomCodeVariableDoc[] = [];

  private readonly destroyRef = inject(DestroyRef);

  private previousSavedCode = '';

  constructor(private readonly dialog: MatDialog) {}

  onExpandView(): void {
    this.dialog
      .open<SmartCartFormCustomCodeDialogComponent, CustomCodeDialogData, CustomCodeDialogResult | null>(
        SmartCartFormCustomCodeDialogComponent,
        {
          ...CUSTOM_CODE_DIALOG_CONFIG,
          data: {
            code: this.codeControl.value,
            defaultCode: this.defaultCode,
            previousCode: this.previousSavedCode,
            variables: this.variables,
          },
        },
      )
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        if (!result) return;
        if (result.code === this.codeControl.value) return;
        this.previousSavedCode = this.codeControl.value;
        this.codeControl.setValue(result.code);
      });
  }
}
